/**
 * Product catalog API contracts (plan #004, U5).
 *
 * Endpoints (all super-admin gated, platform-global — no school scoping):
 *  - GET  /v1/catalog/products            → list products
 *  - POST /v1/catalog/products            → create a product
 *  - PATCH /v1/catalog/products/:id       → update a product
 */

import { z } from 'zod'
import { ProductAudienceSchema, ProductSchema } from '../../schemas/entities/product'

// ----- Create -----

export const CreateProductRequestSchema = z.object({
  slug: z
    .string()
    .trim()
    .min(1, 'Slug is required')
    .regex(/^[a-z0-9-]+$/, 'Slug must be lowercase alphanumeric with hyphens'),
  name: z.string().trim().min(1, 'Name is required'),
  description: z.string().nullable().optional(),
  audience: ProductAudienceSchema,
  isActive: z.boolean().optional()
})
export type CreateProductRequest = z.infer<typeof CreateProductRequestSchema>

// ----- Update (all fields optional except identity) -----

export const UpdateProductRequestSchema = z.object({
  name: z.string().trim().min(1).optional(),
  description: z.string().nullable().optional(),
  audience: ProductAudienceSchema.optional(),
  isActive: z.boolean().optional()
})
export type UpdateProductRequest = z.infer<typeof UpdateProductRequestSchema>

// ----- Responses -----

export const ProductResponseSchema = z.object({
  data: ProductSchema,
  message: z.string()
})
export type ProductResponse = z.infer<typeof ProductResponseSchema>

export const ListProductsResponseSchema = z.object({
  data: z.array(ProductSchema),
  message: z.string()
})
export type ListProductsResponse = z.infer<typeof ListProductsResponseSchema>
